export const normalizeVisibility = value =>
  value === true || value === 1 || value === '1' || value === 'true'

const normalizeCollection = (collection, normalizeItem) => {
  if (Array.isArray(collection)) return collection.map(normalizeItem)

  return Object.entries(collection || {}).reduce(
    (normalized, [key, item]) => ({
      ...normalized,
      [key]: normalizeItem(item),
    }),
    {},
  )
}

export const normalizePropertyLeaseViewPreference = preference => {
  if (!preference) return preference

  return {
    ...preference,
    properties:
      preference.properties == null
        ? preference.properties
        : normalizeCollection(preference.properties, property => ({
            ...property,
            visible: normalizeVisibility(property.visible),
            leases:
              property.leases === undefined
                ? property.leases
                : normalizeCollection(property.leases, lease => ({
                    ...lease,
                    visible: normalizeVisibility(lease.visible),
                  })),
          })),
  }
}

export const getHiddenPropertyAndLeaseIds = preference => {
  const hiddenPropertyIds = []
  const hiddenLeaseIds = []

  Object.values(preference?.properties || {}).forEach(property => {
    if (!normalizeVisibility(property.visible)) {
      hiddenPropertyIds.push(`${property.id}`)
    }
    Object.values(property.leases || {}).forEach(lease => {
      if (!normalizeVisibility(lease.visible)) {
        hiddenLeaseIds.push(`${lease.id}`)
      }
    })
  })

  return { hiddenPropertyIds, hiddenLeaseIds }
}
